import ENV from 'tio-employee/config/environment';
import Store from 'ember-data/store';
import { createTioRequestManager } from 'tio-data/request-manager';

export default class AppStore extends Store {
  // @ts-expect-error: need to do more research on how to type this properly
  constructor(...args) {
    super(...args);

    this.requestManager = createTioRequestManager(this, {
      apiKey: ENV.apiKey,
      contentType: 'application/json',
      sessionRenewal: {
        passToken: false,
      },
    });
  }
}
